import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import axios from 'axios';

import { ErrorFallback, FooterComponent } from 'bxcommon';
import Toaster from 'bxcommon/components/Toaster/Toaster';
import { ModalProvider } from 'bxcommon/context/ModalProvider';
import { RequestListProvider } from 'bxcommon/context/RequestListProvider';
import responseInterceptor from 'bxcommon/interceptors/response.interceptor';
import authHelper from 'bxcommon/helpers/auth.helper';
import errorsService from 'bxcommon/helpers/errors.helper';
import { initToastUtils } from 'bxcommon/store/slices/toaster.slice';

import store from './store';
import RouteList from './RouteList';
import { useGetProspectusListQuery } from './store/endpoints/prospectus.endpoints';

import './App.scss';

axios.defaults.baseURL = import.meta.env.VITE_BASE_URL;

responseInterceptor(store);
authHelper.init('prospectus');
errorsService.init(store);
initToastUtils(store);

const Layout = () => (
  <ModalProvider>
    <div className="primary-layout">
      <div className="primary-layout-content">
        <Toaster />
        <RouteList />
      </div>
      <FooterComponent />
    </div>
  </ModalProvider>
);

const router = createBrowserRouter([{ path: '*', element: <Layout /> }]);

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={store}>
        <RequestListProvider useListQuery={useGetProspectusListQuery}>
          <RouterProvider router={router} />
        </RequestListProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
